import styled from 'styled-components';

export const Wrap = styled.div`
  background-color: var(--pd-grey-bg-color);
  border-radius: 16px;
  padding: 1rem;
  display: flex;
  justify-content: ${(props) => (props.centered ? 'center' : 'space-between')};
  font-weight: bold;
  font-size: 0.8rem;
`;
